import { render, staticRenderFns } from "./External.vue?vue&type=template&id=06b0afef"
import script from "./External.vue?vue&type=script&lang=js"
export * from "./External.vue?vue&type=script&lang=js"
import style0 from "./External.vue?vue&type=style&index=0&id=06b0afef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports